import template from './movimientos-fraccionados.html';
import { FormActions } from 'core/services/form';
import MovimientosFraccionadosI18N from 'i18n/movimientos-fraccionados/es.json';
import { fechaRenderer } from 'core/util';
import { formatErrorMessage } from 'core/util';

export let MovimientosFraccionadosComponent = {
  templateUrl: template,
  selector: 'movimientosFraccionados',
  bindings: {
    translations: '='
  },
  controller: MovimientosFraccionadosCtrl,
  controllerAs: 'vm'
};

const commonsI18N = [
  'Elemento borrado correctamente'
];
export const translationKeys = Object.keys(MovimientosFraccionadosI18N).concat(commonsI18N);

MovimientosFraccionadosCtrl.$inject = [
  'BasicFactory', '$ngRedux', '$state', 'ngNotify', 'Filter', 'AuthorizationService'
];

function MovimientosFraccionadosCtrl(BasicFactory, $ngRedux, $state, ngNotify, Filter,
  AuthorizationService) {

  Object.assign(this, { $state, $ngRedux, ngNotify });
  var defaultColumnOrder = ['numero', 'empleado.nombre', 'empleado.apellido', 'fecha'];
  var staticFilter = Filter.path('activo').eq(true);
  BasicFactory.setup('movimientos-fraccionados');
  const tipoOperacionQuery = Filter.path('tipo.codigo').eq('accion_tipo_comprobante');
  const tipoUrl = encodeURI('valores?filter=' + JSON.stringify(tipoOperacionQuery));
  const aplicarQuery = Filter.path('tipo.codigo').eq('aplicar_tipo_movimiento_fraccionado');
  const aplicarUrl = encodeURI('valores?filter=' + JSON.stringify(aplicarQuery));

  this.options = {
    resource: 'movimientos-fraccionados',
    hideHeader: true,
    hasOptions: true,
    title: this.translations['Listado de movimientos fraccionados'],
    factory: BasicFactory,
    defaultColumnOrder: defaultColumnOrder,
    columns: [
      { data: 'id', title: 'Id' },
      { data: 'numero', title: this.translations['Número'] },
      { data: 'empleado.nombre', title: this.translations['Nombre'] },
      { data: 'empleado.apellido', title: this.translations['Apellido'] },
      { data: 'fecha', title: this.translations['Fecha'], type: 'date-range', renderWith: fechaRenderer },
      { data: 'tipoMovimientoFraccionado.nombre', title: this.translations['Tipo movimiento fraccionado'] },
      // { data: 'periodoFraccionado.nombre', title: this.translations['Periodo nómina'] },
      {
        data: 'tipoMovimientoFraccionado.tipoOperacion.value',
        title: this.translations['Tipo de operación'],
        type: 'combo',
        filterUrl: tipoUrl,
        idField: 'value',
        textField: 'value',
        keyData: 'data'
      }
    ],
    defaultOrderColumn: 0,
    defaultOrderDir: 'desc',
    onEdit: onEdit.bind(this),
    onRemove: onRemove.bind(this),
    onView: onView.bind(this),
    canEditCondition: AuthorizationService.hasPermission.bind(this, 'update_movimientos_fraccionados'),
    canRemoveCondition: AuthorizationService.hasPermission.bind(this, 'delete_movimientos_fraccionados'),
    extraRowOptions: [
      {
        templateToRender: '<button class="btn-row-datatable btn btn-primary btn-dt" uib-tooltip="' + this.translations['Generar Movimientos de Nómina'] + '" ng-show="canEdit()" ng-click="generarMovimientoNomina(<%=dataId%>)"> <span class="glyph-icon icon-signal" style="top: -8px;"></span></button>',
        functionName: 'generarMovimientoNomina',
        functionDef: (itemId) => {
          ngNotify.set('Movimientos generados', 'success');
        }
      }
    ]
  };
  this.handleStatus = handleStatus.bind(this);
  this.mapStateToThis = mapStateToThis.bind(this);
  this.gotoForm = gotoForm.bind(this);
  const unsubscribe = $ngRedux.connect(this.mapStateToThis, FormActions)(this);

  this.$onDestroy = () => {
    this.form();
    unsubscribe();
  };

  this.$onInit = () => {
    this.reportOptions = {
      title: this.translations['Listado de movimientos fraccionados']
    };
    this.form();
  };


  function mapStateToThis(state) {

    this.handleStatus(state);
    return { form: state.form };
  }

  function handleStatus(state) {
    if (state.form.removed) {
      this.ngNotify.set(this.translations['Elemento borrado correctamente'], 'success');
      this.options.reloadData();
      this.form();
    }
    if (state.form.error) {
      ngNotify.set(formatErrorMessage(state.form.error.message), { type: 'error', html: true });
    }

  }

  function gotoForm() {
    this.$state.go('home.movimientos-fraccionados.new');
  }

  function onEdit(itemId) {
    this.$state.go('home.movimientos-fraccionados.uid.edit', { uid: itemId });
  }

  function onRemove(itemId) {
    this.remove('movimientos-fraccionados', itemId);
  }

  function onView(itemId) {
    this.$state.go('home.movimientos-fraccionados.uid.view', { uid: itemId });
  }
}


// WEBPACK FOOTER //
// ./src/components/movimientos-fraccionados/list/movimientos-fraccionados.component.js